import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { QuizTypesDataService, QuizTypesColumnsService } from '../../../services';
import { QuizType, QuizTypesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-quiz-type-form',
  templateUrl: './quiz-type-form.component.html',
  styleUrls: ['./quiz-type-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class QuizTypeFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public quizType: QuizType = {};
  public quizTypeForm: FormGroup = new FormGroup({});
  public quizTypes: QuizType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private quizTypesDataService: QuizTypesDataService,
    public quizTypesColumnsService: QuizTypesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'QuizTypeFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Quiz Type - Edit');
        this.getQuizType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizType !== 'undefined') {
      this.quizType = this.dynamicDialogConfig.data.quizType;
    }
    if (typeof this.quizType.id === 'undefined' || this.quizType.id === null) {
      this.quizType.id = null;
      this.quizType.isPublished = false;
    }
    this.getQuizTypes();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'QuizTypeFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'QuizTypeFormComponent');
  }

  getQuizType(id: number): void {
    this.isLoading = true;
    this.quizTypesDataService.getQuizType(id).subscribe((response: QuizType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizType = response;
        this.prepareFrom();
      }
    });
  }

  getQuizTypes(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizTypes !== 'undefined' && this.dynamicDialogConfig.data.quizTypes.length > 0) {
      this.quizTypes = this.dynamicDialogConfig.data.quizTypes;
      return;
    }
    this.quizTypesDataService.getQuizTypes(this.parameters).subscribe((response: QuizTypesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizTypes = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.quizTypeForm = new FormGroup({
      id: new FormControl(this.quizType.id, []),
      name: new FormControl(this.quizType.name, [Validators.required, ]),
      nameAr: new FormControl(this.quizType.nameAr, []),
      nameFr: new FormControl(this.quizType.nameFr, []),
      slug: new FormControl(this.quizType.slug, [Validators.required, ]),
      slugAr: new FormControl(this.quizType.slugAr, []),
      slugFr: new FormControl(this.quizType.slugFr, []),
      maxQuestionTime: new FormControl(this.quizType.maxQuestionTime, [Validators.required, ]),
      maxQuestions: new FormControl(this.quizType.maxQuestions, [Validators.required, ]),
      questionPoints: new FormControl(this.quizType.questionPoints, [Validators.required, ]),
      description: new FormControl(this.quizType.description, []),
      descriptionAr: new FormControl(this.quizType.descriptionAr, []),
      descriptionFr: new FormControl(this.quizType.descriptionFr, []),
      picture: new FormControl(this.quizType.picture, []),
      isPublished: new FormControl(this.quizType.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/quiz-types']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.quizTypeForm.controls).forEach((field: any) => {
        const control = this.quizTypeForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.quizTypeForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.quizType = this.quizTypeForm.value;
    this.disableSubmit = true;
    console.log('quizType', this.quizType);
    if (typeof this.quizType.id !== 'undefined' && this.quizType.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.quizTypesDataService.updateQuizType(this.quizType).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('QUIZTYPEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('QUIZTYPENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.quizTypesDataService.addQuizType(this.quizType).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('QUIZTYPECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('QUIZTYPENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.quizTypeForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'quiz-types',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.quizTypeForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-quiz-type-form',
  templateUrl: './quiz-type-form.component.html',
  styleUrls: ['./quiz-type-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogQuizTypeFormComponent extends QuizTypeFormComponent {
}

